import type { OrganizationInfo } from '../model/types/organization.dto';

import { apiSlice } from '@/app/api/api';

export const organizationsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		me: builder.query<OrganizationInfo, void>({
			query: () => ({
				url: `auth/me`,
			}),
			providesTags: ['ORGANIZATIONS'],
		}),
	}),
	overrideExisting: false,
});

export const { useMeQuery, useLazyMeQuery } = organizationsApiSlice;
